import { UserOutlined } from "@ant-design/icons"
import { Avatar, Divider, Flex, Typography } from "antd"
import React from "react"

import type { User } from "../../../../LoginPage/types/auth.types.ts"

interface SettingsAboutSectionProps {
  GCCOwners?: User[]
}

export function SettingsAboutSection({ GCCOwners }: SettingsAboutSectionProps) {
  return (
    <Flex vertical gap="small">
      <Typography.Text>
        EzBuild is a platform for managing construction projects, connecting
        contractors, subcontractors, and customers in one place.
      </Typography.Text>
      <Typography.Text type="secondary">
        Version {import.meta.env.VITE_APP_VERSION}
      </Typography.Text>
      <Divider size={"small"} />
      {!!GCCOwners?.length && (
        <Flex vertical gap={8}>
          <Typography.Text className="font-semibold">
            GCC Owner{GCCOwners.length > 1 ? "s" : ""}:
          </Typography.Text>
          {GCCOwners.map((item) => {
            const fullName = [
              item?.first_name,
              item?.middle_name,
              item?.last_name
            ]
              .filter(Boolean)
              .join(" ")

            return (
              <Flex key={item.email} align="center" gap={10}>
                <Avatar src={item.avatar} size={36} icon={<UserOutlined />} />
                <Flex vertical gap={0}>
                  <Typography.Text>{fullName}</Typography.Text>
                  <Typography.Link href={`mailto:${item.email}`}>
                    {item.email}
                  </Typography.Link>
                </Flex>
              </Flex>
            )
          })}
        </Flex>
      )}
    </Flex>
  )
}
